import type { SignatureRequestsResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils/logging';

import { zodSignatureRequestsResponseSchema } from './validations';

/**
 * Fetches signature requests for a delivery note from the API.
 *
 * @param deliveryNoteId - The ID of the delivery note.
 * @returns A promise that resolves with the signature requests.
 * @throws Error if the API request fails.
 */
export const fetchSignatureRequests = async (
  deliveryNoteId: UUID,
): Promise<SignatureRequestsResponse> => {
  const response = await vestigasApi
    .get(ENDPOINT.DELIVERY_NOTE.GET_SIGNATURE_REQUESTS(deliveryNoteId))
    .json<SignatureRequestsResponse>();

  const validatedResponse =
    zodSignatureRequestsResponseSchema.safeParse(response);

  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'Signature requests API response has validation errors',
      error: {
        errors: validatedResponse?.error?.issues,
        errorMessage: validatedResponse?.error?.message,
        response,
      },
    });
  }

  return response;
};
